module.exports = __webpack_public_path__ + "static/about-me-d2dbb9413ab969fc0eb0cd614a6c576b.jpg";